<template>
    <b-modal size="xl" ref="questionnairePopupModal" ok-only no-close-on-backdrop scrollable :title="getTitle">
        <b-container>
            <b-table striped hover :items="questions" :fields="fields" responsive="sm">
                <template #cell(question)="data">
                    <span :style="(data.item.relevant == 1) ? 'color: black' : 'color: #aaaaaa'">
                       {{ data.item['question_' + $i18n.locale] }}
                    </span>
                </template>
                <template #cell(answer)="data">
                    {{ data.value[$i18n.locale] ? data.value[$i18n.locale] : data.value }}
                </template>
            </b-table>
        </b-container>
    </b-modal>
</template>
    <script>
    import riskService from '../../../../../services/Riskmanagement/RiskService';
    export default {
        name: 'questionnaire-popup',
        data() {
            return {
                user: {display_name: ""},
                questionnaire: {name_de: "", name_en: ""},
                questions: [],
                fields: [
                    { key: 'question', label: this.$t('scdda_evaluation.own.col_question') },
                    { key: 'answer', label: this.$t('scdda_evaluation.own.col_answer') },
                    { key: 'score', label: this.$t('scdda_evaluation.own.col_questionscore') },
            ],
            }
        },
        methods: {
            showModal(user, questionnaire) {
                this.$store.commit('loading/setLoading', true);
                this.user = user;
                this.questionnaire = questionnaire;
                riskService.listQuestionRisks(this.user.id, this.questionnaire.id)
                    .then(response => {
                        this.questions = response;
                        this.$store.commit('loading/setLoading', false);
                    }).catch(error => {
                        this.$store.commit('loading/setLoading', false);
                    });
                this.$refs.questionnairePopupModal.show();
            },
            hideModal() {
                this.$refs.questionnairePopupModal.hide();
            },
        },
        computed: {
            getTitle() {
                return (this.questionnaire ? this.questionnaire['name_' + this.$i18n.locale] : "") + ' / ' + this.user?.display_name;
            }
        }
    }
    </script>
